export default __webpack_public_path__ + "static/media/Elec9.16dc63b3.png";